import { useExperiment } from '@m/hooks/data/experiments';

const EXPERIMENT_NAME = 'web_express_onboarding_everywhere';

type SignInOnboardingExperimentGroup = 'control' | 'treatment';

export type SignInOnboardingExperimentState =
  { status: 'pending' } | { status: SignInOnboardingExperimentGroup };

export function useSignInOnboardingExperiment(): SignInOnboardingExperimentState {
  const { data, isPending } = useExperiment(EXPERIMENT_NAME);

  if (isPending) return { status: 'pending' };
  return { status: data?.group === 'treatment' ? 'treatment' : 'control' };
}
